import {
  BASEMAP_STYLES,
  DEFAULT_MAP_CENTER,
  INIT_MAP_CONFIG,
} from "../constants";
import {
  GRAPH_MODE,
  MAP_EXPLORER_MODE,
  getModeDefaults,
} from "../hooks/useFilters/filterDefaults";

export { GRAPH_MODE, MAP_EXPLORER_MODE };

export const COLOR_BY_VALUES = [
  "locationTypes",
  "parameterGroups",
  "wqData",
  "default",
];

export const DEFAULT_BASEMAP = BASEMAP_STYLES[0].style;

export const DEFAULT_CAMERA = {
  zoom: INIT_MAP_CONFIG.zoom,
  lat: DEFAULT_MAP_CENTER[1],
  lng: DEFAULT_MAP_CENTER[0],
  bearing: 0,
  pitch: 0,
};

/**
 * Default values for everything the URL can express, for a given mode.
 * Filter defaults come from the same source the filters are initialized with
 */
export const getUrlDefaults = (mode, filtersData) => {
  const filterDefaults = getModeDefaults(mode, filtersData);

  if (mode === GRAPH_MODE) {
    return {
      ...filterDefaults,
      colorBy: "wqData",
      resultsPanel: true,
      legend: true,
    };
  }

  return {
    ...filterDefaults,
    colorBy: "locationTypes",
  };
};

export const getLayerGroupKey = (layer) =>
  (layer && layer.lreProperties && layer.lreProperties.layerGroup) || layer.id;

/**
 * `{ [groupKey]: boolean }`. A group's visibility is the visibility of the
 * first layer with that key, matching the LayersControl UI.
 */
export const getDefaultLayerVisibility = (layers) => {
  const visibility = {};
  (layers || []).forEach((layer) => {
    const key = getLayerGroupKey(layer);
    if (key in visibility) return;
    visibility[key] = !!(layer.layout && layer.layout.visibility === "visible");
  });
  return visibility;
};

/**
 * `{ [layerId]: number 0..1 }` for fill layers with a numeric fill-opacity.
 */
export const getDefaultOpacity = (layers) => {
  const opacity = {};
  (layers || []).forEach((layer) => {
    const value = layer && layer.paint && layer.paint["fill-opacity"];
    if (layer.type === "fill" && typeof value === "number") {
      opacity[layer.id] = value;
    }
  });
  return opacity;
};
